import {whitelabelling as Whitelabelling} from 'whitelabelling';

export function userInputCareerGoalsIndustries() {
    return {
        restrict: 'E',
        scope: {
            data: '=',
            displayType: '@?',
            required: '<?',
        },
        templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/directives/userInputs/userInputCareerGoalsIndustries.html',
        controller: [
            '$scope', 'RegistrationService', function($scope, RegistrationService) {
                $scope.showAddIndustry = false;
                $scope.whitelabelling = Whitelabelling;

                $scope.MAX_TO_ADD = 10;
                $scope.industries = [];

                $scope.industriesSelector = {
                    value: null,
                };

                RegistrationService.getRegistrationSettings().then(function(d) {
                    $scope.industries = d.Industries;
                });

                $scope.removeIndustry = function(e) {
                    $scope.data.remove(e);
                };

                $scope.industriesTipResource = function() {
                    return RegistrationService.getTopIndustries();
                };

                $scope.goToNextStep = function() {
                    $scope.$emit('goToNextStep');
                };

                $scope.$on('showErrors', function() {
                    $scope.noInputs = true;
                });

                // because we can add multiple concentrations, we have the intermediate value to store the
                // currently selecting one
                $scope.$watch('industriesSelector.value', function(newVal) {
                    if (newVal) {
                        $scope.data.add(newVal);
                        $scope.noInputs = false;
                        $scope.industriesSelector.value = '';
                        $scope.showAddIndustry = $scope.data.length < $scope.MAX_TO_ADD;
                    }
                });
            },
        ],
    };
}

